{
  "code": "EX-00",
  "COMPANY_TYPE": "Pharma",
  "LOGO_ICON": "/assets/imgs/logo__consumo.png"
}
